import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Search } from "lucide-react";
import { t } from "../../lib/i18n";

const NAV_LINKS = [
  { to: "/", label: t("nav.home"), testid: "nav-home" },
  { to: "/services", label: t("nav.services"), testid: "nav-services" },
  { to: "/plan", label: t("nav.plan"), testid: "nav-plan" },
  { to: "/help", label: t("nav.help"), testid: "nav-help" },
];

export default function Header({ onOpenSearch, onOpenMenu }) {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={[
        "sticky top-0 z-40 border-b transition-all duration-300",
        scrolled
          ? "border-[#EAE3D2] bg-[#FAF7F2]/90 backdrop-blur-md"
          : "border-transparent bg-[#FAF7F2]",
      ].join(" ")}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-6 sm:py-5">
        <Link to="/" data-testid="brand-wordmark" className="inline-flex items-baseline gap-1.5">
          <span className="font-display text-xl tracking-[0.08em] text-[#1A1A1A] sm:text-2xl">
            Shutter
          </span>
          <span className="font-display text-xl tracking-[0.08em] text-[#C8A24B] sm:text-2xl">
            KART
          </span>
        </Link>

        <nav className="hidden items-center gap-8 text-sm tracking-wide text-[#1A1A1A]/70 md:flex">
          {NAV_LINKS.map((l) => {
            const active = pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={[
                  "transition hover:text-[#1A1A1A]",
                  active ? "text-[#1A1A1A]" : "",
                ].join(" ")}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            data-testid="header-search-button"
            aria-label={t("nav.search")}
            onClick={onOpenSearch}
            className="rounded-full p-2 text-[#1A1A1A]/70 transition hover:bg-[#EAE3D2]/40 hover:text-[#1A1A1A]"
          >
            <Search className="h-5 w-5" />
          </button>
          <Link
            to="/track"
            data-testid="nav-track"
            className="hidden rounded-full border border-[#1A1A1A]/15 px-4 py-1.5 text-xs uppercase tracking-[0.2em] transition hover:border-[#C8A24B] hover:text-[#C8A24B] md:inline-block"
          >
            Track your request
          </Link>
          <button
            type="button"
            data-testid="header-menu-button"
            aria-label={t("nav.menu")}
            onClick={onOpenMenu}
            className="rounded-full p-2 text-[#1A1A1A]/70 transition hover:bg-[#EAE3D2]/40 hover:text-[#1A1A1A] md:hidden"
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
